import logo from './logo.svg';
import "./global.scss";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getTheme } from "./theme";
import DashboardPage from './pages/DashboardPage';
import { SignalRProvider } from './SignalR/useSignalR';
import LoginPage from './pages/Login';
import AppRoutes from './routes';
import AuthProvider from './provider/authProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const theme = getTheme();
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <CssBaseline />
            <AuthProvider>
          <SignalRProvider>
            <AppRoutes />
            {/* <DashboardPage/> */}
            {/* <LoginPage/> */}
            {/* <BrowserRouter>
              <Suspense fallback={<></>}>
                <AppRoutes />
              </Suspense>
            </BrowserRouter>  */}

          </SignalRProvider>
            </AuthProvider>
        </LocalizationProvider>
        
        {/* Global Toast Container - bottom-right position to avoid blocking UI */}
        <ToastContainer
          position="bottom-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
          limit={3}
        />
      </ThemeProvider>
    </div>
  );
}

export default App;
